// components
import { CopyButton } from '@newo/ui-kit';
import { ICallLog } from '@newo/api/gateway';
import CodeHighlight from '@/components/CodeHighlight';
import ButtonSpoiler from '@/modules/ActLogDrawer/components/Runtime/components/ButtonSpoiler';
import DateTime from '@/modules/DateTime/components/DateTime';
import AgentMessage from '@/modules/Chat/components/AgentMessage';
import ExecutionTime from '@/modules/ActLogDrawer/components/Runtime/components/ExecutionTime';
import GenerationDetails from '@/modules/ActLogDrawer/components/Runtime/components/GenerationDetails';
import ContentViewer from '@/components/ContentViewer';
// utils
import { DATE_FORMAT } from '@/const';

interface BlockProps {
    block: ICallLog;
}
const Block = ({ block: { data } }: BlockProps) => {
    return (
        <div className="text-xs">
            <div className="text-blue-8">{data.name}</div>
            <div className="pl-4">
                {data.parameters.map(({ name, value }, index) => {
                    if (data.name === 'SendMessage' && name === 'message') {
                        return (
                            <div className="col-span-2" key={index}>
                                <AgentMessage
                                    className="mb-1"
                                    content={value}
                                />
                            </div>
                        );
                    }

                    if (data.name === 'gen' && data.source_type === 'skill') {
                        return (
                            <div className="col-span-2" key={index}>
                                <AgentMessage
                                    className="mb-1"
                                    content={data.result}
                                />
                            </div>
                        );
                    }

                    if (name === 'prompt') {
                        return (
                            <div className="col-span-2" key={index}>
                                <ButtonSpoiler
                                    className="pt-2"
                                    hideText="Hide Prompt"
                                    key={index}
                                    showText="Show Prompt"
                                >
                                    <ContentViewer
                                        className="bg-gray-1"
                                        content={value}
                                    />
                                </ButtonSpoiler>
                            </div>
                        );
                    }
                    return (
                        <div className="flex gap-2" key={index}>
                            <span>{name}:</span>
                            <span className="break-all text-gray-6">
                                {value}
                            </span>
                        </div>
                    );
                })}
            </div>
            {data.prompt_script ? (
                <ButtonSpoiler
                    className="py-2 ml-4"
                    hideText="Hide Skill Script"
                    showText="Show Skill Script"
                >
                    <CodeHighlight>{data.prompt_script}</CodeHighlight>
                </ButtonSpoiler>
            ) : undefined}
            <ExecutionTime
                className="pl-4 flex gap-2"
                time={data.execution_time_ms}
            />
            {data.generation_observability ? (
                <GenerationDetails
                    className="pl-4"
                    observability={data.generation_observability}
                />
            ) : undefined}
            {data.prompt_script ? (
                <>
                    <div className="pl-4 flex gap-2">
                        <span>Execution start:</span>
                        <span className="text-gray-6">
                            <DateTime
                                format={DATE_FORMAT.FULL_12H_MS}
                                value={data.execution_start}
                            />
                        </span>
                    </div>
                    <div className="pl-4 flex gap-2">
                        <span>Execution end:</span>
                        <span className="text-gray-6">
                            <DateTime
                                format={DATE_FORMAT.FULL_12H_MS}
                                value={data.execution_end}
                            />
                        </span>
                    </div>
                </>
            ) : undefined}

            <div className="pl-4 mt-2">
                {data.runtime_context_id ? (
                    <div className="flex gap-2">
                        <span>Runtime Context Id:</span>{' '}
                        <span className="text-gray-6">
                            {data.runtime_context_id}
                        </span>
                        <CopyButton value={data.runtime_context_id} />
                    </div>
                ) : undefined}
                {data.external_event_id ? (
                    <div className="flex gap-2">
                        <span>External Event Id:</span>{' '}
                        <span className="text-gray-6">
                            {data.external_event_id}
                        </span>
                        <CopyButton value={data.external_event_id} />
                    </div>
                ) : undefined}
            </div>
        </div>
    );
};

export default Block;
